import { Trans, useTranslation } from 'react-i18next';

import { FNS, GOSUSLUGI, StyledTooltipLink } from '@shared/index';

export const InnTooltipText = () => {
  const { t } = useTranslation();

  return (
    <StyledTooltipLink>
      <Trans
        values={{ href1: GOSUSLUGI, href2: FNS }}
        components={{ a: <a /> }}
      >
        {t('PERSONAL_DOCUMENTS:tooltips.inn-gosuslugi-and-fns')}
      </Trans>
    </StyledTooltipLink>
  );
};
